module.exports = __webpack_public_path__ + "static/media/IVY-05.c560ab67.png";